/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * zen/v1/thread_service.proto
 * OpenAPI spec version: version not set
 */
import { useInfiniteQuery, useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import * as axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

import type {
  ListQueuedThreadMessagesParams,
  ListThreadMessagesParams,
  ListThreadsParams,
  RpcStatus,
  ThreadServiceAddThreadMessageBody,
  ThreadServiceArchiveThreadBody,
  ThreadServiceCancelThreadMessageBody,
  ThreadServiceResumeMessageStreamBody,
  ThreadServiceResumeMessageStreamSseBody,
  ThreadServiceSendMessageBody,
  ThreadServiceSendMessageStreamBody,
  ThreadServiceStopThreadBody,
  ThreadServiceStreamThreadMessagesBody,
  UpdateThreadBody,
  V1ListQueuedThreadMessagesResponse,
  V1ListThreadMessagesResponse,
  V1ListThreadsResponse,
  V1Thread,
  V1ThreadMessage,
} from '../models';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> =
  (<T>() => T extends X ? 1 : 2) extends <T>() => T extends Y ? 1 : 2 ? A : B;

type WritableKeys<T> = {
  [P in keyof T]-?: IfEquals<
    { [Q in P]: T[P] },
    { -readonly [Q in P]: T[P] },
    P
  >;
}[keyof T];

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (
  k: infer I,
) => void
  ? I
  : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>]
  ? {
      [P in keyof Writable<T>]: T[P] extends object
        ? NonReadonly<NonNullable<T[P]>>
        : T[P];
    }
  : DistributeReadOnlyOverUnions<T>;

/**
 * @summary List threads by their resource name.
 */
export const listThreads = (
  organization: string,
  workspace: string,
  agent: string,
  params?: ListThreadsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListThreadsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agent}/threads`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getListThreadsQueryKey = (
  organization?: string,
  workspace?: string,
  agent?: string,
  params?: ListThreadsParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agent}/threads`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListThreadsQueryOptions = <
  TData = Awaited<ReturnType<typeof listThreads>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agent: string,
  params?: ListThreadsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listThreads>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListThreadsQueryKey(organization, workspace, agent, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listThreads>>> = ({
    signal,
  }) =>
    listThreads(organization, workspace, agent, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && agent),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listThreads>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListThreadsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listThreads>>
>;
export type ListThreadsQueryError = AxiosError<RpcStatus>;

export function useListThreads<
  TData = Awaited<ReturnType<typeof listThreads>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agent: string,
  params: undefined | ListThreadsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listThreads>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listThreads>>,
          TError,
          Awaited<ReturnType<typeof listThreads>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListThreads<
  TData = Awaited<ReturnType<typeof listThreads>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agent: string,
  params?: ListThreadsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listThreads>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listThreads>>,
          TError,
          Awaited<ReturnType<typeof listThreads>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListThreads<
  TData = Awaited<ReturnType<typeof listThreads>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agent: string,
  params?: ListThreadsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listThreads>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List threads by their resource name.
 */

export function useListThreads<
  TData = Awaited<ReturnType<typeof listThreads>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agent: string,
  params?: ListThreadsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listThreads>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListThreadsQueryOptions(
    organization,
    workspace,
    agent,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a new thread bound to a specific agent.
 */
export const createThread = (
  organization: string,
  workspace: string,
  agent: string,
  v1Thread: NonReadonly<V1Thread>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Thread>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agent}/threads`,
    v1Thread,
    options,
  );
};

export const getCreateThreadMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createThread>>,
    TError,
    {
      organization: string;
      workspace: string;
      agent: string;
      data: NonReadonly<V1Thread>;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    agent: string;
    data: NonReadonly<V1Thread>;
  },
  TContext
> => {
  const mutationKey = ['createThread'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createThread>>,
    {
      organization: string;
      workspace: string;
      agent: string;
      data: NonReadonly<V1Thread>;
    }
  > = props => {
    const { organization, workspace, agent, data } = props ?? {};

    return createThread(organization, workspace, agent, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateThreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof createThread>>
>;
export type CreateThreadMutationBody = NonReadonly<V1Thread>;
export type CreateThreadMutationError = AxiosError<RpcStatus>;

/**
 * @summary Create a new thread bound to a specific agent.
 */
export const useCreateThread = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createThread>>,
      TError,
      {
        organization: string;
        workspace: string;
        agent: string;
        data: NonReadonly<V1Thread>;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    agent: string;
    data: NonReadonly<V1Thread>;
  },
  TContext
> => {
  const mutationOptions = getCreateThreadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get a thread by its resource name.
 */
export const getThread = (
  organization: string,
  workspace: string,
  automation: string,
  agent: string,
  thread: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Thread>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agent}/threads/${thread}`,
    options,
  );
};

export const getGetThreadQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  agent?: string,
  thread?: string,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agent}/threads/${thread}`,
  ] as const;
};

export const getGetThreadQueryOptions = <
  TData = Awaited<ReturnType<typeof getThread>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agent: string,
  thread: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getThread>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetThreadQueryKey(organization, workspace, automation, agent, thread);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getThread>>> = ({
    signal,
  }) =>
    getThread(organization, workspace, automation, agent, thread, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation && agent && thread),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getThread>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetThreadQueryResult = NonNullable<
  Awaited<ReturnType<typeof getThread>>
>;
export type GetThreadQueryError = AxiosError<RpcStatus>;

export function useGetThread<
  TData = Awaited<ReturnType<typeof getThread>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agent: string,
  thread: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getThread>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getThread>>,
          TError,
          Awaited<ReturnType<typeof getThread>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetThread<
  TData = Awaited<ReturnType<typeof getThread>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agent: string,
  thread: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getThread>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getThread>>,
          TError,
          Awaited<ReturnType<typeof getThread>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetThread<
  TData = Awaited<ReturnType<typeof getThread>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agent: string,
  thread: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getThread>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a thread by its resource name.
 */

export function useGetThread<
  TData = Awaited<ReturnType<typeof getThread>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agent: string,
  thread: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getThread>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetThreadQueryOptions(
    organization,
    workspace,
    automation,
    agent,
    thread,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update an existing thread.
 */
export const updateThread = (
  organization: string,
  workspace: string,
  automation: string,
  agent: string,
  thread: string,
  updateThreadBody: NonReadonly<UpdateThreadBody>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Thread>> => {
  return axios.default.patch(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agent}/threads/${thread}`,
    updateThreadBody,
    options,
  );
};

export const getUpdateThreadMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateThread>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agent: string;
      thread: string;
      data: NonReadonly<UpdateThreadBody>;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agent: string;
    thread: string;
    data: NonReadonly<UpdateThreadBody>;
  },
  TContext
> => {
  const mutationKey = ['updateThread'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateThread>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agent: string;
      thread: string;
      data: NonReadonly<UpdateThreadBody>;
    }
  > = props => {
    const { organization, workspace, automation, agent, thread, data } =
      props ?? {};

    return updateThread(
      organization,
      workspace,
      automation,
      agent,
      thread,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateThreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateThread>>
>;
export type UpdateThreadMutationBody = NonReadonly<UpdateThreadBody>;
export type UpdateThreadMutationError = AxiosError<RpcStatus>;

/**
 * @summary Update an existing thread.
 */
export const useUpdateThread = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateThread>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agent: string;
        thread: string;
        data: NonReadonly<UpdateThreadBody>;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agent: string;
    thread: string;
    data: NonReadonly<UpdateThreadBody>;
  },
  TContext
> => {
  const mutationOptions = getUpdateThreadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List all messages in a thread with pagination support.
 */
export const listThreadMessages = (
  organization: string,
  workspace: string,
  automation: string,
  agent: string,
  thread: string,
  params?: ListThreadMessagesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListThreadMessagesResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agent}/threads/${thread}/messages`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getListThreadMessagesInfiniteQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  agent?: string,
  thread?: string,
  params?: ListThreadMessagesParams,
) => {
  return [
    'infinite',
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agent}/threads/${thread}/messages`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListThreadMessagesQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  agent?: string,
  thread?: string,
  params?: ListThreadMessagesParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agent}/threads/${thread}/messages`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListThreadMessagesInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof listThreadMessages>>,
    ListThreadMessagesParams['page_token']
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agent: string,
  thread: string,
  params?: ListThreadMessagesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listThreadMessages>>,
        TError,
        TData,
        QueryKey,
        ListThreadMessagesParams['page_token']
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListThreadMessagesInfiniteQueryKey(
      organization,
      workspace,
      automation,
      agent,
      thread,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listThreadMessages>>,
    QueryKey,
    ListThreadMessagesParams['page_token']
  > = ({ signal, pageParam }) =>
    listThreadMessages(
      organization,
      workspace,
      automation,
      agent,
      thread,
      { ...params, page_token: pageParam || params?.['page_token'] },
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation && agent && thread),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listThreadMessages>>,
    TError,
    TData,
    QueryKey,
    ListThreadMessagesParams['page_token']
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListThreadMessagesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listThreadMessages>>
>;
export type ListThreadMessagesInfiniteQueryError = AxiosError<RpcStatus>;

export function useListThreadMessagesInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listThreadMessages>>,
    ListThreadMessagesParams['page_token']
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agent: string,
  thread: string,
  params: undefined | ListThreadMessagesParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listThreadMessages>>,
        TError,
        TData,
        QueryKey,
        ListThreadMessagesParams['page_token']
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listThreadMessages>>,
          TError,
          Awaited<ReturnType<typeof listThreadMessages>>,
          QueryKey
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListThreadMessagesInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listThreadMessages>>,
    ListThreadMessagesParams['page_token']
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agent: string,
  thread: string,
  params?: ListThreadMessagesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listThreadMessages>>,
        TError,
        TData,
        QueryKey,
        ListThreadMessagesParams['page_token']
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listThreadMessages>>,
          TError,
          Awaited<ReturnType<typeof listThreadMessages>>,
          QueryKey
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListThreadMessagesInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listThreadMessages>>,
    ListThreadMessagesParams['page_token']
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agent: string,
  thread: string,
  params?: ListThreadMessagesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listThreadMessages>>,
        TError,
        TData,
        QueryKey,
        ListThreadMessagesParams['page_token']
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List all messages in a thread with pagination support.
 */

export function useListThreadMessagesInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listThreadMessages>>,
    ListThreadMessagesParams['page_token']
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agent: string,
  thread: string,
  params?: ListThreadMessagesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listThreadMessages>>,
        TError,
        TData,
        QueryKey,
        ListThreadMessagesParams['page_token']
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListThreadMessagesInfiniteQueryOptions(
    organization,
    workspace,
    automation,
    agent,
    thread,
    params,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListThreadMessagesQueryOptions = <
  TData = Awaited<ReturnType<typeof listThreadMessages>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agent: string,
  thread: string,
  params?: ListThreadMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listThreadMessages>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListThreadMessagesQueryKey(
      organization,
      workspace,
      automation,
      agent,
      thread,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listThreadMessages>>
  > = ({ signal }) =>
    listThreadMessages(
      organization,
      workspace,
      automation,
      agent,
      thread,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation && agent && thread),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listThreadMessages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListThreadMessagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listThreadMessages>>
>;
export type ListThreadMessagesQueryError = AxiosError<RpcStatus>;

export function useListThreadMessages<
  TData = Awaited<ReturnType<typeof listThreadMessages>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agent: string,
  thread: string,
  params: undefined | ListThreadMessagesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listThreadMessages>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listThreadMessages>>,
          TError,
          Awaited<ReturnType<typeof listThreadMessages>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListThreadMessages<
  TData = Awaited<ReturnType<typeof listThreadMessages>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agent: string,
  thread: string,
  params?: ListThreadMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listThreadMessages>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listThreadMessages>>,
          TError,
          Awaited<ReturnType<typeof listThreadMessages>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListThreadMessages<
  TData = Awaited<ReturnType<typeof listThreadMessages>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agent: string,
  thread: string,
  params?: ListThreadMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listThreadMessages>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List all messages in a thread with pagination support.
 */

export function useListThreadMessages<
  TData = Awaited<ReturnType<typeof listThreadMessages>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agent: string,
  thread: string,
  params?: ListThreadMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listThreadMessages>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListThreadMessagesQueryOptions(
    organization,
    workspace,
    automation,
    agent,
    thread,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get a specific thread message by its resource name.
 */
export const getThreadMessage = (
  organization: string,
  workspace: string,
  automation: string,
  agent: string,
  thread: string,
  message: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ThreadMessage>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agent}/threads/${thread}/messages/${message}`,
    options,
  );
};

export const getGetThreadMessageQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  agent?: string,
  thread?: string,
  message?: string,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agent}/threads/${thread}/messages/${message}`,
  ] as const;
};

export const getGetThreadMessageQueryOptions = <
  TData = Awaited<ReturnType<typeof getThreadMessage>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agent: string,
  thread: string,
  message: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getThreadMessage>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetThreadMessageQueryKey(
      organization,
      workspace,
      automation,
      agent,
      thread,
      message,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getThreadMessage>>
  > = ({ signal }) =>
    getThreadMessage(
      organization,
      workspace,
      automation,
      agent,
      thread,
      message,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(
      organization &&
      workspace &&
      automation &&
      agent &&
      thread &&
      message
    ),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getThreadMessage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetThreadMessageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getThreadMessage>>
>;
export type GetThreadMessageQueryError = AxiosError<RpcStatus>;

export function useGetThreadMessage<
  TData = Awaited<ReturnType<typeof getThreadMessage>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agent: string,
  thread: string,
  message: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getThreadMessage>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getThreadMessage>>,
          TError,
          Awaited<ReturnType<typeof getThreadMessage>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetThreadMessage<
  TData = Awaited<ReturnType<typeof getThreadMessage>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agent: string,
  thread: string,
  message: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getThreadMessage>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getThreadMessage>>,
          TError,
          Awaited<ReturnType<typeof getThreadMessage>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetThreadMessage<
  TData = Awaited<ReturnType<typeof getThreadMessage>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agent: string,
  thread: string,
  message: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getThreadMessage>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a specific thread message by its resource name.
 */

export function useGetThreadMessage<
  TData = Awaited<ReturnType<typeof getThreadMessage>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agent: string,
  thread: string,
  message: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getThreadMessage>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetThreadMessageQueryOptions(
    organization,
    workspace,
    automation,
    agent,
    thread,
    message,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Cancel an ongoing message processing operation.
This stops the agent from continuing to process the message.
Deprecated: Message cancellation is no longer supported in the new streaming model.
 */
export const cancelThreadMessage = (
  organization: string,
  workspace: string,
  automation: string,
  agent: string,
  thread: string,
  message: string,
  threadServiceCancelThreadMessageBody: ThreadServiceCancelThreadMessageBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ThreadMessage>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agent}/threads/${thread}/messages/${message}:cancel`,
    threadServiceCancelThreadMessageBody,
    options,
  );
};

export const getCancelThreadMessageMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelThreadMessage>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agent: string;
      thread: string;
      message: string;
      data: ThreadServiceCancelThreadMessageBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelThreadMessage>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agent: string;
    thread: string;
    message: string;
    data: ThreadServiceCancelThreadMessageBody;
  },
  TContext
> => {
  const mutationKey = ['cancelThreadMessage'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelThreadMessage>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agent: string;
      thread: string;
      message: string;
      data: ThreadServiceCancelThreadMessageBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      agent,
      thread,
      message,
      data,
    } = props ?? {};

    return cancelThreadMessage(
      organization,
      workspace,
      automation,
      agent,
      thread,
      message,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelThreadMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelThreadMessage>>
>;
export type CancelThreadMessageMutationBody =
  ThreadServiceCancelThreadMessageBody;
export type CancelThreadMessageMutationError = AxiosError<RpcStatus>;

/**
 * @summary Cancel an ongoing message processing operation.
This stops the agent from continuing to process the message.
Deprecated: Message cancellation is no longer supported in the new streaming model.
 */
export const useCancelThreadMessage = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof cancelThreadMessage>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agent: string;
        thread: string;
        message: string;
        data: ThreadServiceCancelThreadMessageBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof cancelThreadMessage>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agent: string;
    thread: string;
    message: string;
    data: ThreadServiceCancelThreadMessageBody;
  },
  TContext
> => {
  const mutationOptions = getCancelThreadMessageMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List queued messages in a thread that are waiting to be processed.
 */
export const listQueuedThreadMessages = (
  organization: string,
  workspace: string,
  automation: string,
  agent: string,
  thread: string,
  params?: ListQueuedThreadMessagesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListQueuedThreadMessagesResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agent}/threads/${thread}/messages:queued`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getListQueuedThreadMessagesQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  agent?: string,
  thread?: string,
  params?: ListQueuedThreadMessagesParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agent}/threads/${thread}/messages:queued`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListQueuedThreadMessagesQueryOptions = <
  TData = Awaited<ReturnType<typeof listQueuedThreadMessages>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agent: string,
  thread: string,
  params?: ListQueuedThreadMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listQueuedThreadMessages>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListQueuedThreadMessagesQueryKey(
      organization,
      workspace,
      automation,
      agent,
      thread,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listQueuedThreadMessages>>
  > = ({ signal }) =>
    listQueuedThreadMessages(
      organization,
      workspace,
      automation,
      agent,
      thread,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation && agent && thread),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listQueuedThreadMessages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListQueuedThreadMessagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listQueuedThreadMessages>>
>;
export type ListQueuedThreadMessagesQueryError = AxiosError<RpcStatus>;

export function useListQueuedThreadMessages<
  TData = Awaited<ReturnType<typeof listQueuedThreadMessages>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agent: string,
  thread: string,
  params: undefined | ListQueuedThreadMessagesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listQueuedThreadMessages>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listQueuedThreadMessages>>,
          TError,
          Awaited<ReturnType<typeof listQueuedThreadMessages>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListQueuedThreadMessages<
  TData = Awaited<ReturnType<typeof listQueuedThreadMessages>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agent: string,
  thread: string,
  params?: ListQueuedThreadMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listQueuedThreadMessages>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listQueuedThreadMessages>>,
          TError,
          Awaited<ReturnType<typeof listQueuedThreadMessages>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListQueuedThreadMessages<
  TData = Awaited<ReturnType<typeof listQueuedThreadMessages>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agent: string,
  thread: string,
  params?: ListQueuedThreadMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listQueuedThreadMessages>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List queued messages in a thread that are waiting to be processed.
 */

export function useListQueuedThreadMessages<
  TData = Awaited<ReturnType<typeof listQueuedThreadMessages>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agent: string,
  thread: string,
  params?: ListQueuedThreadMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listQueuedThreadMessages>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListQueuedThreadMessagesQueryOptions(
    organization,
    workspace,
    automation,
    agent,
    thread,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Stream thread messages in real-time as they are generated.
Deprecated: Use ResumeMessageStream instead for reconnection scenarios.
 */
export const streamThreadMessages = (
  organization: string,
  workspace: string,
  automation: string,
  agent: string,
  thread: string,
  threadServiceStreamThreadMessagesBody: ThreadServiceStreamThreadMessagesBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Blob>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agent}/threads/${thread}/messages:stream`,
    threadServiceStreamThreadMessagesBody,
    {
      responseType: 'blob',
      ...options,
    },
  );
};

export const getStreamThreadMessagesMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof streamThreadMessages>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agent: string;
      thread: string;
      data: ThreadServiceStreamThreadMessagesBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof streamThreadMessages>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agent: string;
    thread: string;
    data: ThreadServiceStreamThreadMessagesBody;
  },
  TContext
> => {
  const mutationKey = ['streamThreadMessages'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof streamThreadMessages>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agent: string;
      thread: string;
      data: ThreadServiceStreamThreadMessagesBody;
    }
  > = props => {
    const { organization, workspace, automation, agent, thread, data } =
      props ?? {};

    return streamThreadMessages(
      organization,
      workspace,
      automation,
      agent,
      thread,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type StreamThreadMessagesMutationResult = NonNullable<
  Awaited<ReturnType<typeof streamThreadMessages>>
>;
export type StreamThreadMessagesMutationBody =
  ThreadServiceStreamThreadMessagesBody;
export type StreamThreadMessagesMutationError = AxiosError<RpcStatus>;

/**
 * @summary Stream thread messages in real-time as they are generated.
Deprecated: Use ResumeMessageStream instead for reconnection scenarios.
 */
export const useStreamThreadMessages = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof streamThreadMessages>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agent: string;
        thread: string;
        data: ThreadServiceStreamThreadMessagesBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof streamThreadMessages>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agent: string;
    thread: string;
    data: ThreadServiceStreamThreadMessagesBody;
  },
  TContext
> => {
  const mutationOptions = getStreamThreadMessagesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Add a new client-initiated message to an existing thread.
Deprecated: Use SendMessage instead, which returns a stream of ThreadMessage events.
 */
export const addThreadMessage = (
  organization: string,
  workspace: string,
  automation: string,
  agent: string,
  thread: string,
  threadServiceAddThreadMessageBody: ThreadServiceAddThreadMessageBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ThreadMessage>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agent}/threads/${thread}:addMessage`,
    threadServiceAddThreadMessageBody,
    options,
  );
};

export const getAddThreadMessageMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addThreadMessage>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agent: string;
      thread: string;
      data: ThreadServiceAddThreadMessageBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addThreadMessage>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agent: string;
    thread: string;
    data: ThreadServiceAddThreadMessageBody;
  },
  TContext
> => {
  const mutationKey = ['addThreadMessage'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addThreadMessage>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agent: string;
      thread: string;
      data: ThreadServiceAddThreadMessageBody;
    }
  > = props => {
    const { organization, workspace, automation, agent, thread, data } =
      props ?? {};

    return addThreadMessage(
      organization,
      workspace,
      automation,
      agent,
      thread,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AddThreadMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof addThreadMessage>>
>;
export type AddThreadMessageMutationBody = ThreadServiceAddThreadMessageBody;
export type AddThreadMessageMutationError = AxiosError<RpcStatus>;

/**
 * @summary Add a new client-initiated message to an existing thread.
Deprecated: Use SendMessage instead, which returns a stream of ThreadMessage events.
 */
export const useAddThreadMessage = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addThreadMessage>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agent: string;
        thread: string;
        data: ThreadServiceAddThreadMessageBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addThreadMessage>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agent: string;
    thread: string;
    data: ThreadServiceAddThreadMessageBody;
  },
  TContext
> => {
  const mutationOptions = getAddThreadMessageMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Archive a thread, hiding it from normal listings.
Archived threads can still be accessed directly by name.
 */
export const archiveThread = (
  organization: string,
  workspace: string,
  automation: string,
  agent: string,
  thread: string,
  threadServiceArchiveThreadBody: ThreadServiceArchiveThreadBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Thread>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agent}/threads/${thread}:archive`,
    threadServiceArchiveThreadBody,
    options,
  );
};

export const getArchiveThreadMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof archiveThread>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agent: string;
      thread: string;
      data: ThreadServiceArchiveThreadBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof archiveThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agent: string;
    thread: string;
    data: ThreadServiceArchiveThreadBody;
  },
  TContext
> => {
  const mutationKey = ['archiveThread'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof archiveThread>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agent: string;
      thread: string;
      data: ThreadServiceArchiveThreadBody;
    }
  > = props => {
    const { organization, workspace, automation, agent, thread, data } =
      props ?? {};

    return archiveThread(
      organization,
      workspace,
      automation,
      agent,
      thread,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ArchiveThreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof archiveThread>>
>;
export type ArchiveThreadMutationBody = ThreadServiceArchiveThreadBody;
export type ArchiveThreadMutationError = AxiosError<RpcStatus>;

/**
 * @summary Archive a thread, hiding it from normal listings.
Archived threads can still be accessed directly by name.
 */
export const useArchiveThread = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof archiveThread>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agent: string;
        thread: string;
        data: ThreadServiceArchiveThreadBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof archiveThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agent: string;
    thread: string;
    data: ThreadServiceArchiveThreadBody;
  },
  TContext
> => {
  const mutationOptions = getArchiveThreadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * If `from_message_id` is set on the request, the server first replays every
persisted ThreadMessage with a `name` lexicographically greater than that
value (the catchup phase), then transitions to live tail.
 * @summary Resume streaming messages for the most recent user message in a thread.
Returns remaining messages for the last user message that haven't been
delivered yet. If processing is complete (no pending messages), the stream
closes immediately. This is useful for resuming after a client disconnect.
 */
export const resumeMessageStream = (
  organization: string,
  workspace: string,
  automation: string,
  agent: string,
  thread: string,
  threadServiceResumeMessageStreamBody: ThreadServiceResumeMessageStreamBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Blob>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agent}/threads/${thread}:resumeStream`,
    threadServiceResumeMessageStreamBody,
    {
      responseType: 'blob',
      ...options,
    },
  );
};

export const getResumeMessageStreamMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resumeMessageStream>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agent: string;
      thread: string;
      data: ThreadServiceResumeMessageStreamBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resumeMessageStream>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agent: string;
    thread: string;
    data: ThreadServiceResumeMessageStreamBody;
  },
  TContext
> => {
  const mutationKey = ['resumeMessageStream'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resumeMessageStream>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agent: string;
      thread: string;
      data: ThreadServiceResumeMessageStreamBody;
    }
  > = props => {
    const { organization, workspace, automation, agent, thread, data } =
      props ?? {};

    return resumeMessageStream(
      organization,
      workspace,
      automation,
      agent,
      thread,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ResumeMessageStreamMutationResult = NonNullable<
  Awaited<ReturnType<typeof resumeMessageStream>>
>;
export type ResumeMessageStreamMutationBody =
  ThreadServiceResumeMessageStreamBody;
export type ResumeMessageStreamMutationError = AxiosError<RpcStatus>;

/**
 * @summary Resume streaming messages for the most recent user message in a thread.
Returns remaining messages for the last user message that haven't been
delivered yet. If processing is complete (no pending messages), the stream
closes immediately. This is useful for resuming after a client disconnect.
 */
export const useResumeMessageStream = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof resumeMessageStream>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agent: string;
        thread: string;
        data: ThreadServiceResumeMessageStreamBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof resumeMessageStream>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agent: string;
    thread: string;
    data: ThreadServiceResumeMessageStreamBody;
  },
  TContext
> => {
  const mutationOptions = getResumeMessageStreamMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary SSE (Server-Sent Events) variant of ResumeMessageStream. Same semantics,
but served as text/event-stream. SSE clients should populate
`from_message_id` from the `Last-Event-ID` HTTP request header on
reconnect; the server replays catchup events before live tailing.
 */
export const resumeMessageStreamSse = (
  organization: string,
  workspace: string,
  automation: string,
  agent: string,
  thread: string,
  threadServiceResumeMessageStreamSseBody: ThreadServiceResumeMessageStreamSseBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<string>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agent}/threads/${thread}:resumeStreamSse`,
    threadServiceResumeMessageStreamSseBody,
    {
      ...options,
    },
  );
};

export const getResumeMessageStreamSseMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resumeMessageStreamSse>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agent: string;
      thread: string;
      data: ThreadServiceResumeMessageStreamSseBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resumeMessageStreamSse>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agent: string;
    thread: string;
    data: ThreadServiceResumeMessageStreamSseBody;
  },
  TContext
> => {
  const mutationKey = ['resumeMessageStreamSse'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resumeMessageStreamSse>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agent: string;
      thread: string;
      data: ThreadServiceResumeMessageStreamSseBody;
    }
  > = props => {
    const { organization, workspace, automation, agent, thread, data } =
      props ?? {};

    return resumeMessageStreamSse(
      organization,
      workspace,
      automation,
      agent,
      thread,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ResumeMessageStreamSseMutationResult = NonNullable<
  Awaited<ReturnType<typeof resumeMessageStreamSse>>
>;
export type ResumeMessageStreamSseMutationBody =
  ThreadServiceResumeMessageStreamSseBody;
export type ResumeMessageStreamSseMutationError = AxiosError<RpcStatus>;

/**
 * @summary SSE (Server-Sent Events) variant of ResumeMessageStream. Same semantics,
but served as text/event-stream. SSE clients should populate
`from_message_id` from the `Last-Event-ID` HTTP request header on
reconnect; the server replays catchup events before live tailing.
 */
export const useResumeMessageStreamSse = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof resumeMessageStreamSse>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agent: string;
        thread: string;
        data: ThreadServiceResumeMessageStreamSseBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof resumeMessageStreamSse>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agent: string;
    thread: string;
    data: ThreadServiceResumeMessageStreamSseBody;
  },
  TContext
> => {
  const mutationOptions = getResumeMessageStreamSseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Send a new user message to a thread and stream the agent's response.
The stream includes the created user message, followed by all agent-generated
messages (progress notifications, artifacts, tool calls, agent messages, etc.)
until a CompletionResponse is received. The stream closes after the
CompletionResponse is sent.
 */
export const sendMessage = (
  organization: string,
  workspace: string,
  automation: string,
  agent: string,
  thread: string,
  threadServiceSendMessageBody: ThreadServiceSendMessageBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Blob>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agent}/threads/${thread}:sendMessage`,
    threadServiceSendMessageBody,
    {
      responseType: 'blob',
      ...options,
    },
  );
};

export const getSendMessageMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendMessage>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agent: string;
      thread: string;
      data: ThreadServiceSendMessageBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendMessage>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agent: string;
    thread: string;
    data: ThreadServiceSendMessageBody;
  },
  TContext
> => {
  const mutationKey = ['sendMessage'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendMessage>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agent: string;
      thread: string;
      data: ThreadServiceSendMessageBody;
    }
  > = props => {
    const { organization, workspace, automation, agent, thread, data } =
      props ?? {};

    return sendMessage(
      organization,
      workspace,
      automation,
      agent,
      thread,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type SendMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendMessage>>
>;
export type SendMessageMutationBody = ThreadServiceSendMessageBody;
export type SendMessageMutationError = AxiosError<RpcStatus>;

/**
 * @summary Send a new user message to a thread and stream the agent's response.
The stream includes the created user message, followed by all agent-generated
messages (progress notifications, artifacts, tool calls, agent messages, etc.)
until a CompletionResponse is received. The stream closes after the
CompletionResponse is sent.
 */
export const useSendMessage = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sendMessage>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agent: string;
        thread: string;
        data: ThreadServiceSendMessageBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof sendMessage>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agent: string;
    thread: string;
    data: ThreadServiceSendMessageBody;
  },
  TContext
> => {
  const mutationOptions = getSendMessageMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary SSE (Server-Sent Events) variant of SendMessage. Same gRPC semantics as
SendMessage, but served over HTTP/1.1+ as a text/event-stream response —
each ThreadMessage is delivered as one SSE event with `id: <name>` and
`data: <single-line-json>`. Application-level heartbeat ThreadMessages are
filtered from the wire; SSE clients rely on the protocol's `: ping`
comment lines for connection keepalive instead.
 */
export const sendMessageStream = (
  organization: string,
  workspace: string,
  automation: string,
  agent: string,
  thread: string,
  threadServiceSendMessageStreamBody: ThreadServiceSendMessageStreamBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<string>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agent}/threads/${thread}:sendMessageStream`,
    threadServiceSendMessageStreamBody,
    {
      ...options,
    },
  );
};

export const getSendMessageStreamMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendMessageStream>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agent: string;
      thread: string;
      data: ThreadServiceSendMessageStreamBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendMessageStream>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agent: string;
    thread: string;
    data: ThreadServiceSendMessageStreamBody;
  },
  TContext
> => {
  const mutationKey = ['sendMessageStream'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendMessageStream>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agent: string;
      thread: string;
      data: ThreadServiceSendMessageStreamBody;
    }
  > = props => {
    const { organization, workspace, automation, agent, thread, data } =
      props ?? {};

    return sendMessageStream(
      organization,
      workspace,
      automation,
      agent,
      thread,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type SendMessageStreamMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendMessageStream>>
>;
export type SendMessageStreamMutationBody = ThreadServiceSendMessageStreamBody;
export type SendMessageStreamMutationError = AxiosError<RpcStatus>;

/**
 * @summary SSE (Server-Sent Events) variant of SendMessage. Same gRPC semantics as
SendMessage, but served over HTTP/1.1+ as a text/event-stream response —
each ThreadMessage is delivered as one SSE event with `id: <name>` and
`data: <single-line-json>`. Application-level heartbeat ThreadMessages are
filtered from the wire; SSE clients rely on the protocol's `: ping`
comment lines for connection keepalive instead.
 */
export const useSendMessageStream = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sendMessageStream>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agent: string;
        thread: string;
        data: ThreadServiceSendMessageStreamBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof sendMessageStream>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agent: string;
    thread: string;
    data: ThreadServiceSendMessageStreamBody;
  },
  TContext
> => {
  const mutationOptions = getSendMessageStreamMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Stop a thread, terminating any ongoing message processing.
 */
export const stopThread = (
  organization: string,
  workspace: string,
  automation: string,
  agent: string,
  thread: string,
  threadServiceStopThreadBody: ThreadServiceStopThreadBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Thread>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agent}/threads/${thread}:stop`,
    threadServiceStopThreadBody,
    options,
  );
};

export const getStopThreadMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof stopThread>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agent: string;
      thread: string;
      data: ThreadServiceStopThreadBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof stopThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agent: string;
    thread: string;
    data: ThreadServiceStopThreadBody;
  },
  TContext
> => {
  const mutationKey = ['stopThread'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof stopThread>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agent: string;
      thread: string;
      data: ThreadServiceStopThreadBody;
    }
  > = props => {
    const { organization, workspace, automation, agent, thread, data } =
      props ?? {};

    return stopThread(
      organization,
      workspace,
      automation,
      agent,
      thread,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type StopThreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof stopThread>>
>;
export type StopThreadMutationBody = ThreadServiceStopThreadBody;
export type StopThreadMutationError = AxiosError<RpcStatus>;

/**
 * @summary Stop a thread, terminating any ongoing message processing.
 */
export const useStopThread = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof stopThread>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agent: string;
        thread: string;
        data: ThreadServiceStopThreadBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof stopThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agent: string;
    thread: string;
    data: ThreadServiceStopThreadBody;
  },
  TContext
> => {
  const mutationOptions = getStopThreadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
